// ----
/**
 * Nps event name - store type
 * @type {{INITIAL: string, CHANGE: string, RESET: string, APPEAR: string}}
 */
const type = {
  INITIAL: 'type-NPS-INITIAL',
  CHANGE: 'type-NPS-CHANGE',
  RESET: 'type-NPS-RESET',
  APPEAR: 'type-NPS-APPEAR',
};

/**
 * Nps store initial values
 * @type {{payload: {name: string, checked: null, value: null}, meta: {appear: boolean}, type: (string)}}
 */
const initial = {
  type: type.INITIAL,
  payload: {
    checked: null,
    name: '',
    value: null,
  },
  meta: {
    appear: false,
  },
};

/**
 * Nps - `redux.dispatch` 受信し `type` により処理分岐させます
 * @param {*} requestState 元情報
 * @param {*} action 伝達された情報
 * @return {{payload: {name: string, checked: null, value: null}, type: *}} 変化後の state を返します
 */
const behavior = (requestState = { ...initial }, action = null) => {
  const state = { ...requestState };
  if (!action || !action.type) {
    // state.type = type.INITIAL;
    return state;
  }

  switch (action.type) {
    case type.CHANGE: {
      // Nps radio.onchange で呼び出します
      state.type = action.type;
      state.payload.checked = action.payload.checked;
      state.payload.value = action.payload.value;
      state.payload.name = action.payload.name;
      return state;
    }
    case type.RESET: {
      state.type = action.type;
      state.payload.checked = null;
      state.payload.value = null;
      state.payload.name = '';
      return state;
    }
    case type.INITIAL: {
      state.type = action.type;
      return state;
    }
    case type.APPEAR: {
      // Nps 出現
      state.type = action.type;
      state.meta.appear = true;
      return state;
    }
    default: {
      return state;
    }
  }
};

/**
 * nps component 状態を管理する `redux` 関連 module
 * @type {{initial: *, type: *, behavior: *}}
 */
const nps = {
  type,
  initial,
  behavior,
};

export default nps;



// WEBPACK FOOTER //
// ./src/embedded-type/broadcast/actions/nps.js